import { Button } from "@mui/material";
import { useDispatch } from "react-redux";
import { openBidPopup } from "@/nav/navSlice";

export default function ProjectBidCreate({ project }) {
    const dispatch = useDispatch();
    const popupType = project?.confirmed_bid_id ? "Change Order" : "Bid Sheet";
    const label = project.legacy_bid
        ? `Switch to Integrated`
        : `Create ${popupType}`;

    const handlePopupOpen = () => {
        dispatch(
            openBidPopup({
                type: popupType,
                projectId: project?.id,
            }),
        );
    };

    return (
        <div>
            <Button
                variant="contained"
                onClick={handlePopupOpen}
                data-testid="project-create-bid"
            >
                {label}
            </Button>
        </div>
    );
}
